// extracted by mini-css-extract-plugin
export default {"details":"details__YTY1O","facets":"facets__ZGUyM","location":"location__NTM5Z","pricing":"pricing__Y2Q1Y","dot":"dot__ZmJmM","detailsItem":"detailsItem__YzQxM"};